import {
    CabinetMesh,
    RoomPlannerProduct,
} from 'components/customer/RoomPlanner/types';
import {store} from 'store/customer';

export const getProductDifferences = (
    products: RoomPlannerProduct[],
    cabinetGroupList?: CabinetMesh[]
) => {
    if (!store) return;

    const state = store.getState();
    const deletedIds = state.roomPlanner.deletedIds;

    const removed: CabinetMesh[] = [];

    const productMap = products.map(
        (product) => product.duplicate_id || product.id
    );

    cabinetGroupList.forEach((cabinetGroup) => {
        const cabinetId = cabinetGroup.userData.id;

        if (!productMap.includes(cabinetId)) {
            removed.push(cabinetGroup);
        } else {
            productMap.splice(productMap.indexOf(cabinetId), 1);
        }
    });

    const added = productMap
        .map((id) =>
            products.find(
                (product) => product.duplicate_id === id || product.id === id
            )
        )
        .filter((product) => {
            return !deletedIds.includes(Number(product.job_cabinet_id));
        });

    return {
        added,
        removed,
    };
};
